module.exports = __webpack_public_path__ + "img/user_group_add.f5f5b764.svg";